import { getPostBody, getPostBySlug } from '@/content/blog/loadPosts';
import { Box, Button, Chip, Divider, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Link, useParams } from 'react-router-dom';

import { BlogMarkdown } from '@/components/Marketing/BlogMarkdown';
import { MarketingPageShell } from '@/components/Marketing/MarketingPageShell';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;
  const body = slug ? getPostBody(slug) : undefined;

  usePageMeta(post?.title ?? 'Blog', post?.description);

  if (!slug || !post || !body) {
    return (
      <MarketingPageShell title="Article not found" showHero>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          We could not find that article.
        </Typography>
        <Button component={Link} to="/blog" variant="contained">
          Back to blog
        </Button>
      </MarketingPageShell>
    );
  }

  return (
    <MarketingPageShell title={post.title} subtitle={post.description} showHero>
      <Chip
        label={post.category}
        size="small"
        sx={{ mb: 2 }}
        color="primary"
        variant="outlined"
      />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {format(new Date(post.publishedAt), 'MMMM d, yyyy')} ·{' '}
        {post.readTimeMinutes} min read
      </Typography>
      <BlogMarkdown content={body} />
      <Divider sx={{ my: 4 }} />
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {post.author.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {post.author.role}
        </Typography>
      </Box>
      <Button component={Link} to="/blog" variant="outlined" sx={{ mt: 3 }}>
        Back to blog
      </Button>
    </MarketingPageShell>
  );
}
